import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import {
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  Matches,
} from 'class-validator';
import { RegionTimeType } from '../enums/region-time-window.enum';

const TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

/**
 * A time window seeded together with a new region (no regionId: the region
 * does not exist yet when the payload is built).
 */
export class RegionTimeWindowSeedDto {
  @ApiProperty({
    description: 'Window start time in HH:MM:SS format',
    example: '08:00:00',
  })
  @IsNotEmpty()
  @IsString()
  @Matches(TIME_PATTERN, {
    message: 'windowStartTime must be in HH:MM:SS format',
  })
  @Expose()
  windowStartTime!: string;

  @ApiProperty({
    description: 'Window end time in HH:MM:SS format',
    example: '11:00:00',
  })
  @IsNotEmpty()
  @IsString()
  @Matches(TIME_PATTERN, {
    message: 'windowEndTime must be in HH:MM:SS format',
  })
  @Expose()
  windowEndTime!: string;

  @ApiPropertyOptional({
    title: 'Region Time Type',
    enum: RegionTimeType,
    default: RegionTimeType.HO_SERVICE,
  })
  @IsOptional()
  @IsEnum(RegionTimeType)
  @Expose()
  regionTimeType?: RegionTimeType;
}

/**
 * H/O service windows every new region starts with. Kept here so the API
 * seeds them and the admin can display them without a second source of truth.
 */
export const DEFAULT_HO_SERVICE_TIME_WINDOWS: ReadonlyArray<
  Required<RegionTimeWindowSeedDto>
> = [
  {
    windowStartTime: '08:00:00',
    windowEndTime: '11:00:00',
    regionTimeType: RegionTimeType.HO_SERVICE,
  },
  {
    windowStartTime: '11:00:00',
    windowEndTime: '14:00:00',
    regionTimeType: RegionTimeType.HO_SERVICE,
  },
  {
    windowStartTime: '14:00:00',
    windowEndTime: '17:00:00',
    regionTimeType: RegionTimeType.HO_SERVICE,
  },
];
